<template >
  <v-app class="back">
    <v-container fluid class="doc">
      <v-row>
        <v-col md="12">
          <span class="display-1 titulo font-weight-bold">
            Participantes
            <span v-if="evento_nome">- {{ evento_nome }}</span>
          </span>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" sm="12" md="12">
          <v-card flat width="100%" class="borda">
            <v-card-text>
              <v-container fluid>
                <v-row class="mt-n6">
                  <v-col>
                    <v-card style="overflow-y: auto !important" class="borda" outlined>
                      <v-data-table
                        height="500"
                        hide-default-footer
                        :headers="headers"
                        :items="tabela_participantes"
                        fixed-header
                        class="elevation-0"
                        :search="search"
                        no-results-text="Nenhum resultado encontrado"
                        no-data-text="Não há participantes no evento"
                        :items-per-page="5000"
                      >
                        <template v-slot:footer>
                          <v-divider></v-divider>
                          <v-row>
                            <v-col class="ml-5" md="auto" v-if="editModulo">
                              <v-btn
                                rounded
                                outlined
                                @click="dialog_participante = true"
                                color="#283480"
                              >Novo participante</v-btn>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col class="mr-5" md="auto">
                              <span class="subtitle-1">{{tabela_participantes.length}} participantes</span>
                            </v-col>
                          </v-row>
                        </template>
                        <template v-slot:top>
                          <v-row>
                            <v-col cols="12" md="auto">
                              <v-toolbar flat color="white">
                                <v-toolbar-title>Lista de presença</v-toolbar-title>
                              </v-toolbar>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="12" md="auto" v-if="editModulo">
                              <a
                                href="/documents/lista_participantes_exemplo_meuclube.csv"
                                target="_blank"
                              >
                                <v-btn rounded text class="mt-3 px-5 caption">
                                  <v-icon class="mr-1">mdi-file-download-outline</v-icon>Lista de exemplo para envio
                                </v-btn>
                              </a>
                            </v-col>
                            <v-col md="auto" class="mr-4" v-if="editModulo">
                              <v-btn
                                color="#283480"
                                class="text-none mt-3 px-5 white--text"
                                rounded
                                depressed
                                :loading="isSelecting"
                                @click="onButtonClick"
                              >
                                <v-icon left>mdi-cloud-upload</v-icon>
                                <span>{{ nome_botao }}</span>
                              </v-btn>
                              <input
                                class="d-none"
                                ref="uploader"
                                type="file"
                                accept=".csv"
                                @change="onFileChanged"
                              />
                            </v-col>
                          </v-row>
                          <v-row no-gutters v-if="tabela_participantes.length > 3">
                            <v-text-field
                              solo
                              dense
                              flat
                              outlined
                              v-model="search"
                              class="mx-4"
                              label="Buscar por nome, email ou código"
                            ></v-text-field>
                          </v-row>
                        </template>
                        <template v-slot:item.acao="{ item }">
                          <v-btn icon small v-if="editModulo">
                            <v-icon
                              v-if="item.evento_compra_item_codigo"
                              @click="item_PDF = item, dialog_PDF = true"
                            >mdi-pdf-box</v-icon>
                          </v-btn>
                          <v-tooltip top color="black" v-if="!editModulo">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon v-bind="attrs" v-on="on" text>
                                <v-icon>mdi-information-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>
                              Sem autorização para
                              <span class="orange--text">editar</span> ou
                              <span class="red--text">excluir</span>
                            </span>
                          </v-tooltip>
                          <v-btn icon small v-if="editModulo">
                            <v-icon small @click="editar(item)">mdi-pencil-outline</v-icon>
                          </v-btn>
                          <v-btn icon small v-if="editModulo">
                            <v-icon
                              small
                              @click="dialog_delete = true,id_participante = item.id_evento_participante"
                            >mdi-delete-outline</v-icon>
                          </v-btn>
                        </template>

                        <template v-slot:item.evento_compra_item_codigo="{ item }">
                          <span
                            v-if="item.evento_compra_item_codigo"
                          >{{item.evento_compra_item_codigo}}</span>
                          <span v-else class="ml-4">-</span>
                        </template>

                        <template v-slot:item.evento_compra_item_status="{ item }">
                          <v-chip
                            small
                            color="yellow lighten-3"
                            v-if="item.evento_compra_item_status == 1"
                          >Aguardando</v-chip>
                          <v-chip
                            small
                            color="green lighten-3"
                            v-else-if="item.evento_compra_item_status == 3 || item.evento_compra_item_status == 5"
                          >Confirmado</v-chip>
                          <v-chip
                            small
                            color="green lighten-3"
                            v-else-if="item.evento_compra_item_status == null"
                          >Confirmado</v-chip>
                        </template>
                        <template v-slot:item.participante_status="{ item }">
                          <v-row justify="center">
                            <v-checkbox
                              color="#283480"
                              disabled
                              class="pa-0 mb-n6 ma-0"
                              v-model="item.participante_confirmado_boolean"
                            ></v-checkbox>
                          </v-row>
                        </template>
                      </v-data-table>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- DIALOG NOVO PARTICIPANTE -->
    <v-dialog v-model="dialog_participante" max-width="600px" transition="dialog-transition">
      <v-form ref="form" v-model="valid" @submit.prevent="save_participantes()">
        <v-card flat class="borda">
          <v-card-title class="ma-2">
            Novo Participante
            <v-spacer></v-spacer>
            <v-btn icon text @click="reset()">
              <v-icon>mdi-close-thick</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-col>
                <span class="font-weight-bold black--text">Nome *</span>
                <v-text-field
                  outlined
                  solo
                  :rules="requiredRules"
                  flat
                  dense
                  v-model="novo_participante.participante_nome"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="mt-n8">
              <v-col>
                <span class="font-weight-bold black--text">E-mail</span>
                <span style="font-size: 12px;">(O E-mail será vinculado a um associado caso exista)</span>
                <v-text-field
                  outlined
                  solo
                  :rules="rulesAdicionalEmail"
                  flat
                  dense
                  v-model="novo_participante.participante_email"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="mt-n8">
              <v-col cols="12" sm="12" md="6">
                <span class="font-weight-bold black--text">Telefone</span>
                <v-text-field
                  outlined
                  solo
                  :rules="rulesAdicionalTelefone"
                  flat
                  dense
                  v-mask="telefone"
                  v-model="novo_participante.participante_telefone"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <span class="font-weight-bold black--text">Data de nascimento</span>
                <v-menu
                  v-model="menu5"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      solo
                      flat
                      outlined
                      dense
                      :rules="requiredRulesData"
                      @blur="novo_participante.participante_data_nascimento = parseDate(dateFormatted5)"
                      v-model="dateFormatted5"
                      append-icon="mdi-calendar"
                      clearable
                      v-mask="data_mask"
                      v-on="on"
                      @input="menu5 = false"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date5"
                    ref="picker"
                    :max="new Date().toISOString().substr(0, 10)"
                    no-title
                    locale="pt-br"
                    @input="menu5 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row class="mt-n8">
              <v-col cols="12" sm="12" md="12">
                <span class="font-weight-bold black--text">Observação</span>
                <v-textarea
                  auto-grow
                  dense
                  v-model="novo_participante.participante_observacao"
                  solo
                  rows="1"
                  outlined
                  flat
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row class="mt-n10">
              <v-col>
                <v-checkbox
                  color="#283480"
                  label="Presença confirmada"
                  v-model="participante_confirmado"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="mt-n10">
            <v-row class="mb-4" no-gutters justify="center">
              <v-btn
                class="mr-2"
                :disabled="loading_save"
                rounded
                @click="reset()"
                style="color: #283480 !important"
                outlined
              >Cancelar</v-btn>
              <v-btn
                class="ml-2"
                rounded
                :disabled="loading_save"
                :loading="loading_save"
                @click="save_participantes()"
                style="background-color: #283480  !important; color:#00FFD4  !important"
              >
                <v-icon>mdi-content-save</v-icon>
                <span>Salvar</span>
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- DIALOG EXCLUIR PARTICIPANTE -->
    <v-dialog v-model="dialog_delete" max-width="310">
      <v-card class="borda" flat>
        <v-card-title class="headline">Tem certeza que deseja deletar este item?</v-card-title>
        <v-card-text>Se deletar este item ele não poderá ser recuperado!!</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            rounded
            :disabled="loading_delete"
            @click="dialog_delete = false"
            color="#283480"
          >Cancelar</v-btn>
          <v-btn
            style="background-color: #283480  !important; color:#00FFD4  !important"
            rounded
            :disabled="loading_delete"
            :loading="loading_delete"
            @click="deletar()"
          >Sim, tenho certeza</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_PDF" width="850">
      <dialogPDF :evento="evento_pdf" :item="item_PDF"></dialogPDF>
    </v-dialog>
  </v-app>
</template>

<script>
import Api from "@/common/api.helper";
import moment from "moment";
import dialogPDF from "./evento_ingresso_unico";
export default {
  components: {
    dialogPDF
  },
  data: vm => {
    return {
      editModulo: false,
      dialog_participante: false,
      disabled_atividades: true,
      disabled_ingressos_vendas: true,
      requiredRules: [v => !!v || "Campo Obrigatório."],
      requiredRulesData: [
        v => !v | moment(vm.parseDate(v)).isValid() || "Data inválida"
      ],
      rulesAdicionalEmail: [
        //v => !!v || "Campo Obrigatório.",
        v => !v.length || /.+@.+\..+/.test(v) || "E-mail inválido"
      ],
      rulesAdicionalTelefone: [
        //v => !!v || "Campo Obrigatório.",
        v => !v.length || v.length >= 14 || "Telefone inválido"
      ],
      arquivos: {
        arquivo: []
      },
      loading_delete: false,
      valid: true,
      date5: "",
      dateFormatted5: "",
      data_mask: "##/##/####",
      time_mask: "##:##",
      evento_nome: "Buscando nome...",
      evento_venda_ingresso: false,
      tabela_participantes: [],
      novo_participante: {
        participante_nome: "",
        participante_email: "",
        participante_telefone: "",
        participante_data_nascimento: "",
        participante_confirmado: 0,
        participante_observacao: "",
        fk_id_evento: vm.$route.params.id
      },
      item_PDF: [],
      dialog_PDF: false,
      evento_pdf: [],
      participante_confirmado: false,
      evento_id: null,
      loading_save: false,
      categorias: [],
      id_participante: "",
      menu5: false,
      headers: [
        { text: "Código", align: "start", value: "evento_compra_item_codigo" },
        { text: "Nome", align: "start", value: "participante_nome" },
        { text: "E-mail", value: "participante_email" },
        { text: "Presença", align: "center", value: "participante_status" },
        {
          text: "Status",
          sortable: false,
          value: "evento_compra_item_status"
        },
        { text: "Ações", sortable: false, align: "end", value: "acao" }
      ],
      dialog_delete: false,
      search: "",
      isSelecting: false,
      nome_botao: "Upload lista"
    };
  },
  mounted() {
    if (this.$route.params.id == 0) {
      console.log();
    } else {
      this.validaEdicaoModulo();
      this.getEvento();
      this.getParticipantes();
      this.evento_id = this.$route.params.id;
    }
  },
  computed: {
    computedDateFormatted5() {
      return this.formatDate(this.date5);
    },
    telefone() {
      let telefone = "";
      telefone = "(##) #####-####";
      return telefone;
    }
  },
  watch: {
    date5() {
      this.dateFormatted5 = this.formatDate(this.date5);
      this.novo_participante.novo_participante = this.parseDate(
        this.dateFormatted5
      );
    },
    menu5(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    }
  },
  methods: {
    async validaEdicaoModulo() {
      let rota = this.$router.currentRoute.path;
      if (rota.substr(0, 13) == "/meus_eventos") {
        rota = "/meus_eventos";
      } else {
        rota = "/eventos";
      }
      this.editModulo = await Api.validaEdicaoModulo(rota);
    },
    saveCSV(item) {
      this.isSelecting = true;
      let formData = new FormData();
      Object.keys(item).map(key => {
        if (key === "arquivo") {
          let file = item.arquivo;
          if (item.arquivo.name) {
            formData.append(`arquivo`, file);
          }
        } else {
          if (item[key]) {
            formData.append(key, item[key]);
          }
        }
      });

      Api.post(
        "/eventos/participantes/lista/" + this.$route.params.id,
        formData
      )
        .then(response => {
          if (!response.data.errors) {
            this.$toast.success(response.data.success);
            this.arquivos.arquivo = [];
            this.getParticipantes();
          } else {
            this.$toast.error(response.data.errors);
          }
          this.isSelecting = false;
        })
        .catch(err => {
          this.$toast.error("Falha na leitura do arquivo");
          this.arquivos.arquivo = [];
          this.isSelecting = false;
          throw err;
        });
    },
    onButtonClick() {
      this.isSelecting = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      this.arquivos.arquivo = e.target.files[0];
      this.saveCSV(this.arquivos);
    },
    deletar() {
      this.loading_delete = true;
      Api.delete("/eventos/participantes/" + this.id_participante)
        .then(response => {
          if (response.data.errors) {
            this.$toast.warning(response.data.errors);
          }
          this.$toast.success("Participante excluído com sucesso");

          this.getParticipantes();
          this.dialog_delete = false;
          this.loading_delete = false;
        })
        .catch(err => {
          this.loading_delete = false;
          this.$toast.error(err.response.data.errors);
          throw err;
        });
    },
    editar(item) {
      this.dialog_PDF = false;
      Api.get("/eventos/participantes/" + item.id_evento_participante)
        .then(response => {
          if (!response.data.errors) {
            this.novo_participante = response.data[0];
            this.date5 = this.novo_participante.participante_data_nascimento;
            this.participante_confirmado =
              this.novo_participante.participante_confirmado == 1
                ? true
                : false;
            if (!response.data[0].participante_email) {
              this.novo_participante.participante_email = "";
            }
            if (!response.data[0].participante_telefone) {
              this.novo_participante.participante_telefone = "";
            }
            this.dialog_participante = true;
          } else {
            this.$toast.warning(response.data.errors);
          }
        })
        .catch(err => {
          this.$toast.error("Participante não encontrado");
          throw err;
        });
    },
    getEvento() {
      Api.get("/eventos/show/" + this.$route.params.id)
        .then(response => {
          if (!response.data.errors) {
            let item = response.data[0];
            this.evento_pdf = response.data[0];
            if (response.data[0].evento_venda_ingresso == true) {
              this.disabled_ingressos_vendas = false;
            } else {
              this.disabled_ingressos_vendas = true;
            }
            this.evento_nome = item.evento_nome;
            this.disabled_atividades = false;
          } else {
            this.$toast.warning(response.data.errors);
          }
        })
        .catch(err => {
          this.$toast.error("Evento não encontrado ou sem permissão!");
          setTimeout(() => {
            this.$toast.default("Redirecionando para Eventos!");
          }, 1400);

          setTimeout(() => {
            this.$router.push({ name: "Eventos" });
          }, 5000);
          throw err;
        });
    },

    getParticipantes() {
      Api.get("/eventos/participantes/evento/" + this.$route.params.id)
        .then(response => {
          if (!response.data.errors) {
            this.tabela_participantes = response.data.data;
            for (let i = 0; i < this.tabela_participantes.length; i++) {
              Object.assign(this.tabela_participantes[i], {
                participante_confirmado_boolean:
                  this.tabela_participantes[i].participante_confirmado == 1
                    ? true
                    : false
              });
            }
          }
        })
        .catch(err => {
          this.$toast.error(err.response.errors);
          throw err;
        });
    },
    reset() {
      this.$refs.form.resetValidation();
      this.dialog_participante = false;
      this.date5 = "";
      this.participante_confirmado = false;
      this.novo_participante = {
        participante_nome: "",
        participante_email: "",
        participante_telefone: "",
        participante_data_nascimento: "",
        participante_confirmado: 0,
        participante_observacao: "",
        fk_id_evento: this.$route.params.id
      };
      this.novo_participante.participante_telefone = "";
      this.date5 = "";
    },
    save_participantes() {
      if (this.$refs.form.validate()) {
        this.loading_save = true;
        if (this.participante_confirmado) {
          this.novo_participante.participante_confirmado = 1;
        } else {
          this.novo_participante.participante_confirmado = 0;
        }
        let edit = "";
        if (this.novo_participante.id_evento_participante) {
          edit = "/" + this.novo_participante.id_evento_participante;
        }
        Api.post("/eventos/participantes" + edit, this.novo_participante)
          .then(response => {
            if (!response.data.errors) {
              this.$toast.success("Operação realizada com sucesso!");
              this.getParticipantes();
            } else {
              this.$toast.warning(response.data.errors);
            }
            this.loading_save = false;
            this.novo_participante.participante_telefone = "";
            this.date5 = "";
            this.novo_participante.id_evento_participante = "";
            this.reset();
          })
          .catch(err => {
            this.loading_save = false;
            this.$toast.error(err.response.errors);
            throw err;
          });
      }
    },

    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      if (date.length == 10) {
        const [day, month, year] = date.split("/");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      }
    }
  }
};
</script>